import type { DeveloperTranslation } from './types';

/** Arabic (Modern Standard). Pending review by native speakers. */
export const developerAr: DeveloperTranslation = {
  nav: 'المطوّرون',
  title: 'المطوّرون',
  description:
    'اربط أنظمتك: مفاتيح API لتكامل الخوادم، وخطافات ويب تخبرها بما يحدث، والمضيفات التي يُسمح لـ Hamnivo بالاتصال بها.',
  apiReference: 'مرجع API',
  newTab: '(يفتح في علامة تبويب جديدة)',
  tabs: {
    keys: 'مفاتيح API',
    webhooks: 'خطافات الويب',
    events: 'سجل الأحداث',
    hosts: 'المضيفات المسموح بها',
  },
  reveal: {
    description: 'احفظه في مكان آمن؛ لن يُعرض مرة أخرى.',
    copy: 'نسخ',
    copied: 'تم النسخ',
    copyFailed: 'تعذّر النسخ. النص محدد؛ انسخه بنفسك.',
    once: 'يحتفظ Hamnivo ببصمة له فقط. إذا فُقد، دوِّره للحصول على واحد جديد.',
    done: 'تم',
  },
  permissions: {
    analytics: {
      read: {
        name: 'قراءة التقارير',
        hint: 'مجاميع جودة الخدمة وتصدير CSV. دون محتوى الرسائل.',
      },
    },
    billing: {
      read: { name: 'قراءة الفوترة', hint: 'الخطة والاستخدام مقارنة بحدودها والفواتير.' },
    },
    webhooks: {
      read: {
        name: 'قراءة خطافات الويب',
        hint: 'نقاط الاستقبال وسجل التسليم وأنواع الأحداث. دون أسرار التوقيع.',
      },
    },
    mcp: {
      read: {
        name: 'القراءة عبر MCP',
        hint: 'يتيح لمساعد ذكاء اصطناعي مثل Claude البحث في المحادثات وقراءة ما رآه العملاء والبحث في المعرفة وذاكرة العملاء والتحويلات المفتوحة. للقراءة فقط.',
      },
    },
  },
  keys: {
    title: 'مفاتيح API',
    description:
      'يتيح المفتاح لخادم استدعاء واجهة Hamnivo بصفته حساب خدمة مستقلًا، بالأذونات التي تمنحها له فقط، ولا يتجاوز أذوناتك أبدًا.',
    readOnly: 'يمكنك رؤية المفاتيح، لكن إنشاءها وتغييرها متاح فقط لمن يدير مفاتيح API.',
    loading: 'جارٍ تحميل مفاتيح API',
    empty: 'لا توجد مفاتيح API بعد.',
    neverUsed: 'لم يُستخدم قط',
    scopeTenant: 'مساحة العمل كاملة',
    scopeBrand: 'العلامة التجارية: {{brand}}',
    scopeType: {
      workspace: 'مساحة عمل واحدة',
      brand: 'علامة تجارية واحدة',
      team: 'فريق واحد',
      inbox: 'صندوق وارد واحد',
    },
    status: {
      active: 'نشط',
      rotating: 'قيد الاستبدال',
      expired: 'منتهي الصلاحية',
      revoked: 'مُلغى',
    },
    columns: {
      name: 'الاسم',
      key: 'المفتاح',
      access: 'الصلاحيات',
      status: 'الحالة',
      lastUsed: 'آخر استخدام',
      expires: 'ينتهي',
      actions: 'الإجراءات',
    },
    create: {
      open: 'إنشاء مفتاح',
      title: 'إنشاء مفتاح API',
      description: 'امنح المفتاح ما يحتاجه التكامل فقط. لكل مفتاح تاريخ انتهاء.',
      name: 'الاسم',
      nameHint: 'اسم يوضح مكان استخدامه، مثل «نظام الطلبات».',
      permissions: 'الأذونات',
      notYours: 'لا تملك هذا الإذن بنفسك، لذا لا يمكنك منحه.',
      scope: 'نطاق التطبيق',
      scopeHint: 'الفوترة وخطافات الويب تشمل دائمًا مساحة العمل كاملة.',
      expiry: 'ينتهي بعد',
      expiryHint: 'دوِّر المفتاح قبل انتهائه؛ يمكن أن يستمر القديم في العمل لبعض الوقت.',
      days: '{{count}} يومًا',
      submit: 'إنشاء المفتاح',
    },
    rotate: {
      button: 'تدوير',
      label: 'تدوير {{name}}',
      title: 'تدوير «{{name}}»؟',
      description:
        'ستحصل على مفتاح جديد بالأذونات نفسها. حدّث التكامل لديك، ثم اترك المفتاح القديم ينتهي.',
      overlap: 'يستمر المفتاح القديم في العمل لمدة',
      overlaps: {
        '0': 'لا وقت: يتوقف الآن',
        '60': 'ساعة واحدة',
        '1440': 'يوم واحد',
        '10080': 'أسبوع واحد',
      },
      confirm: 'تدوير المفتاح',
      unchanged: 'لم يُدوَّر المفتاح؛ المفتاح الحالي ما زال يعمل.',
    },
    revoke: {
      button: 'إلغاء',
      label: 'إلغاء {{name}}',
      title: 'إلغاء «{{name}}»؟',
      description: 'تتوقف الطلبات التي تستخدم هذا المفتاح فورًا. لا يمكن التراجع عن ذلك.',
      confirm: 'إلغاء المفتاح',
      done: 'أُلغي {{name}}.',
    },
    reveal: {
      title: 'تم إنشاء مفتاح API',
      label: 'مفتاح API لـ {{name}}',
    },
  },
  webhooks: {
    title: 'خطافات الويب',
    description:
      'يرسل Hamnivo طلبات HTTPS موقّعة إلى نقاط الاستقبال لديك عندما يحدث شيء. لا تُرسل الملاحظات الداخلية أبدًا.',
    add: 'إضافة نقطة استقبال',
    loading: 'جارٍ تحميل نقاط الاستقبال',
    empty: 'لا توجد نقاط استقبال بعد. أضف واحدة لتلقي الأحداث.',
    noDeliveries: 'لم يُرسل شيء بعد',
    eventCount: 'الأحداث: {{count}}',
    open: 'فتح',
    openLabel: 'فتح {{url}}',
    created: 'أُضيفت نقطة الاستقبال',
    secret: 'سر التوقيع',
    secretLabel: 'سر التوقيع',
    verifiedAt: 'تمت الإجابة عن الاختبار {{time}}',
    notVerified: 'لم تُختبر بعد',
    previousValid: 'السر السابق يوقّع أيضًا حتى {{time}}.',
    blocked:
      'مضيف نقطة الاستقبال هذه غير موجود في قائمة المضيفات المسموح بها، لذا تُرفض عمليات التسليم إليها. أضف المضيف في «المضيفات المسموح بها».',
    failingNote:
      'المحاولات الفاشلة المتتالية: {{count}}. تُعاد محاولة التسليم لنحو ثلاثة أيام؛ وتُوقف نقطة الاستقبال التي تستمر في الفشل.',
    edit: 'تعديل',
    status: {
      active: 'نشطة',
      failing: 'تحتاج إلى انتباه',
    },
    disabled: {
      manual: 'متوقفة',
      failing: 'متوقفة: استمر الفشل',
      gone: 'متوقفة: نقطة الاستقبال لم تعد موجودة',
    },
    columns: {
      url: 'العنوان',
      status: 'الحالة',
      events: 'الأحداث',
      latest: 'آخر تسليم',
      open: 'التفاصيل',
    },
    categories: {
      conversations: 'المحادثات',
      messages: 'الرسائل',
      handoffs: 'التحويل إلى الموظفين',
      orders: 'الطلبات',
      payments: 'المدفوعات',
      refunds: 'المبالغ المستردة',
      memory: 'ذاكرة العملاء',
      usage: 'الاستخدام',
      testing: 'الاختبار',
    },
    events: {
      conversation_created: 'بدأت محادثة.',
      conversation_updated: 'تغيّر من يجيب، أو الحالة التي يراها العميل.',
      conversation_resolved: 'حُلّت محادثة.',
      conversation_reopened: 'أُعيد فتح محادثة.',
      message_created: 'أُرسلت رسالة يستطيع العميل رؤيتها.',
      handoff_requested: 'المحادثة بانتظار موظف.',
      handoff_accepted: 'تولّى موظف المحادثة.',
      handoff_returned: 'عادت المحادثة إلى المساعد الذكي.',
      order_created: 'قُدّم طلب.',
      order_updated: 'تغيّرت حالة طلب.',
      payment_updated: 'تغيّرت حالة دفعة.',
      refund_created: 'طُلب استرداد مبلغ.',
      refund_updated: 'تغيّرت حالة استرداد.',
      memory_deleted: 'حُذفت ذاكرة عميل (الإيصال دون المحتوى).',
      usage_threshold_reached: 'بلغ الاستخدام عتبة تنبيه.',
      webhook_test: 'حدث تجريبي أُرسل من Studio أو من الواجهة البرمجية.',
    },
    form: {
      title: 'إضافة نقطة استقبال',
      editTitle: 'تعديل نقطة الاستقبال',
      description: 'استخدم عنوان HTTPS على الإنترنت العام. يُعرض سر التوقيع مرة واحدة بعد الإضافة.',
      url: 'عنوان نقطة الاستقبال',
      urlHint: 'مثال: https://hooks.example.com/hamnivo',
      note: 'الوصف',
      events: 'الأحداث المرسلة',
      submit: 'إضافة نقطة الاستقبال',
      save: 'حفظ التغييرات',
      saved: 'حُفظت نقطة الاستقبال.',
    },
    test: {
      button: 'إرسال حدث تجريبي',
      verified: 'قبلت نقطة الاستقبال الحدث التجريبي الموقّع.',
      verifiedBadge: 'تم التحقق',
      failed: 'لم يُقبل الحدث التجريبي. راجع الإجابة أدناه.',
    },
    rotate: {
      button: 'تدوير السر',
      title: 'تدوير سر التوقيع؟',
      description:
        'خلال فترة التداخل يحمل كل طلب توقيعين، واحدًا لكل سر، كي يتمكن المستقبِل من التبديل دون فقدان أي حدث.',
      overlap: 'الاستمرار في التوقيع بالسر القديم لمدة',
      overlaps: {
        '0': 'لا وقت: يتوقف الآن',
        '1': 'ساعة واحدة',
        '24': 'يوم واحد',
        '72': 'ثلاثة أيام',
      },
      confirm: 'تدوير السر',
      unchanged: 'لم يُدوَّر السر؛ السر الحالي ما زال يوقّع.',
      revealTitle: 'سر توقيع جديد',
    },
    turnOff: {
      button: 'إيقاف',
      title: 'إيقاف نقطة الاستقبال هذه؟',
      description:
        'لن يُرسل إليها شيء بعد الآن، وتُلغى عمليات التسليم المنتظرة لإعادة المحاولة. يمكنك إعادة تشغيلها بعد تفعيلها.',
      confirm: 'إيقاف',
      done: 'أُوقفت نقطة الاستقبال.',
    },
    turnOn: {
      button: 'تفعيل',
      title: 'تفعيل نقطة الاستقبال هذه؟',
      description: 'تُرسل الأحداث الجديدة مرة أخرى، ويبدأ عدد مرات الفشل من الصفر.',
      confirm: 'تفعيل',
      done: 'فُعّلت نقطة الاستقبال.',
    },
    replayFailed: {
      button: 'إعادة إرسال الفاشلة',
      title: 'إعادة إرسال عمليات التسليم الفاشلة؟',
      description:
        'يُعاد إرسال كل تسليم إلى نقطة الاستقبال هذه فشل أو أُلغي خلال المدة، بمعرّف الحدث الأصلي نفسه.',
      since: 'التي فشلت خلال',
      windows: {
        '1': 'آخر 24 ساعة',
        '3': 'آخر 3 أيام',
        '7': 'آخر 7 أيام',
      },
      confirm: 'إعادة الإرسال',
      done: 'عمليات إعادة الإرسال المجدولة: {{count}}. أقدم من أن تُرسل مجددًا: {{expired}}.',
    },
    delete: {
      button: 'حذف',
      title: 'حذف نقطة الاستقبال هذه؟',
      description:
        'يُحذف معها سجل التسليم، وتتوقف أسرار التوقيع الخاصة بها. لا يمكن التراجع عن ذلك.',
      confirm: 'حذف نقطة الاستقبال',
      done: 'حُذفت نقطة الاستقبال.',
    },
  },
  deliveries: {
    title: 'سجل التسليم',
    loading: 'جارٍ تحميل عمليات التسليم',
    loadingDetail: 'جارٍ تحميل التسليم',
    empty: 'لم يُرسل شيء إلى نقطة الاستقبال هذه بعد.',
    detailTitle: 'تفاصيل التسليم',
    event: 'الحدث',
    eventId: 'معرّف الحدث',
    statusLabel: 'الحالة',
    attempts: 'المحاولات',
    attemptsOf: 'المحاولات: {{count}} من {{max}}',
    attemptNumber: 'المحاولة {{number}}',
    nextAttempt: 'المحاولة التالية',
    replayed: 'إعادة إرسال',
    answer: 'الإجابة:',
    preview: 'معاينة الحمولة',
    previewNote: 'يُخفى هنا ما كتبه الأشخاص وهوياتهم؛ تلقّت نقطة الاستقبال الحدث كاملًا.',
    expired: 'تجاوز الحدث مدة الاحتفاظ، لذا لم يعد محتواه محفوظًا.',
    status: {
      pending: 'قيد إعادة المحاولة',
      succeeded: 'تم التسليم',
      failed: 'فشل',
      cancelled: 'أُلغي',
    },
    outcomes: {
      succeeded: 'مقبول',
      http_error: 'إجابة بخطأ',
      redirect: 'إعادة توجيه (لم تُتبع)',
      timeout: 'انتهت المهلة',
      network: 'فشل الاتصال',
      tls: 'مشكلة في الشهادة',
      blocked: 'مرفوض',
      unresolvable: 'المضيف غير موجود',
    },
    replay: {
      button: 'إعادة إرسال هذا التسليم',
      title: 'إعادة إرسال هذا التسليم؟',
      description: 'إرسال الحدث {{event}} مرة أخرى إلى',
      dedupe:
        'على المستقبِلات إزالة التكرار باستخدام معرّف الحدث: تحمل إعادة الإرسال قيمة webhook-id نفسها الموجودة في الأصل.',
      confirm: 'إعادة الإرسال',
      queued: 'جُدولت إعادة الإرسال.',
      turnOnFirst: 'فعّل نقطة الاستقبال لإعادة إرسال عمليات التسليم إليها.',
    },
  },
  events: {
    title: 'سجل الأحداث',
    description: 'الأحداث المرسلة إلى نقاط الاستقبال، الأحدث أولًا، مع ما حدث لعمليات تسليمها.',
    filter: 'نوع الحدث',
    allTypes: 'كل أنواع الأحداث',
    loading: 'جارٍ تحميل الأحداث',
    empty: 'لا توجد أحداث بعد. تُسجَّل الأحداث ما دامت نقطة استقبال واحدة على الأقل مفعّلة.',
    emptyFiltered: 'لا توجد أحداث من هذا النوع بعد.',
    more: 'عرض أحداث أقدم',
    counts: 'سُلِّم {{succeeded}} · فشل {{failed}} · قيد إعادة المحاولة {{pending}}',
    columns: {
      type: 'الحدث',
      id: 'معرّف الحدث',
      occurred: 'وقت الحدوث',
      deliveries: 'عمليات التسليم',
    },
  },
  hosts: {
    title: 'المضيفات المسموح بها',
    description:
      'حدّد المضيفات التي يمكن لـ Hamnivo الاتصال بها لمساحة العمل هذه، مثل نقاط استقبال خطافات الويب. إذا لم تُدرج أي مضيفات، يُسمح بأي مضيف عام.',
    always: 'تُرفض دائمًا الشبكات الخاصة وهذا الخادم والعناوين المحلية، مهما كان المدرج هنا.',
    loading: 'جارٍ تحميل المضيفات المسموح بها',
    modeAny: 'يُسمح بأي مضيف عام.',
    modeList: 'يُسمح فقط بالمضيفات أدناه.',
    empty: 'لا توجد مضيفات مدرجة.',
    pattern: 'المضيف',
    patternHint: 'مضيف مثل hooks.example.com، أو ‎*.example.com لنطاقاته الفرعية.',
    note: 'ملاحظة',
    remove: 'إزالة {{host}}',
    removeShort: 'إزالة',
    add: 'إضافة مضيف',
    save: 'حفظ المضيفات المسموح بها',
    savedList: 'حُفظت المضيفات المسموح بها: {{count}}.',
    savedAny: 'تم الحفظ. يُسمح بأي مضيف عام.',
    readOnly: 'لا يغيّر قائمة الشبكة إلا من يديرها.',
    blocked: 'نقاط الاستقبال هذه غير موجودة في القائمة، لذا تُرفض عمليات التسليم إليها:',
  },
};
